import { Record, List } from 'immutable';

export const initialState = Record({
  list: List(),
});

export const PayCategoryFactory = Record({
  id: null,
  nameId: '',
  icon: '',
  count: 0,
  displayName: '',
  left: 0,
  right: 0,
  level: 1,
  parentId: null,
  visible: false,
  children: List(),
  parentList: List(),
});

// adapters
export const payCategoriesStoreAdapter = (categories) => {
  const list = List(categories.map((category) => PayCategoryFactory(category)));
  return initialState({
    list,
  });
};
